import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generateSettingsAgentResponse = unaryRpc({
  name: "generateSettingsAgentResponse",
  input: z.discriminatedUnion("type", [
    z.object({
      type: z.literal("new"),
      initialMessages: MessageSchema.array(),
      teamId: zExt.objectId(),
    }),
    z.object({
      type: z.literal("continue"),
      threadId: zExt.objectId(),
      moreMessages: MessageSchema.array().optional(),
    }),
  ]),
  output: z.object({ threadId: z.string(), messages: MessageSchema.array() }),
});
